import { render } from "./CreateFile.vue?vue&type=template&id=50412cb4&scoped=true"
import script from "./CreateFile.vue?vue&type=script&lang=js"
export * from "./CreateFile.vue?vue&type=script&lang=js"

import "./CreateFile.vue?vue&type=style&index=0&id=50412cb4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50412cb4"]])

export default __exports__